export class Constants {
    public static version = "1.6.108";
}
